import {
  FieldVal,
  SYSFormField,
} from "../../../../_ovlclient/src/library/forms/fieldapi"
import { SYSFormState } from "../../../../_ovlclient/src/library/forms/formapi"

export const SYSEditorAssetFileGetNameAndExtension = (
  fileName: string
): { name: string; extension: string } => {
  let name
  let extension
  if (fileName) {
    let descValWithoutExtension = fileName.split(".")
    let fileExt = descValWithoutExtension.splice(
      descValWithoutExtension.length - 1
    )
    name = descValWithoutExtension.join(".")
    extension = fileExt[0]
  }
  return { name, extension }
}

export type SYSEditorAssetType = {
  cat: string
  desc: string
  ext: string
  c: number
  val: string
  rev?: number
}

export const SYSEditorAssetSerializeFromFormState = (
  formState: SYSFormState
): string => {
  // limit for uploads per field is 100
  let resVal: SYSEditorAssetType[] = []
  for (let i = 0; i < 100; i++) {
    let instance = i.toString().padStart(2, "0")
    let val = FieldVal(formState.fields[`Val_${instance}`])
    if (val === undefined) {
      break
    }
    if (!val) {
      val = undefined
    }
    // check as well for translated desc here
    // (not implemented in default)

    let desc = FieldVal(formState.fields[`Desc_${instance}`])
    if (!desc) {
      desc = undefined
    }
    let ext = FieldVal(formState.fields[`Ext_${instance}`])
    if (val === undefined || !ext) {
      ext = undefined
    }
    let cat = FieldVal(formState.fields[`Category_${instance}`])
    if (cat === null) {
      cat = undefined
    }
    let chk0 = FieldVal(formState.fields[`Chk0_${instance}`])
    let c
    if (chk0 !== undefined) {
      c = chk0 === true ? 1 : undefined
    }

    let res: SYSEditorAssetType = { cat, desc, ext, val, c }
    resVal.push(res)
  }
  let res: any = resVal
  if (resVal.length === 1) {
    res = resVal[0]
  } else if (resVal.length === 0) {
    return null
  }
  let res2 = JSON.stringify(res)
  if (res2 === "{}") {
    return null
  }
  return res2
}

export const SYSEditorAssetDeserializeToFormFields = (
  fields: { [key: string]: SYSFormField },
  assetFieldValue: string
): { [key: string]: SYSFormField } => {
  // make a copy of the formfied def
  if (!assetFieldValue) {
    return
  }
  let assetFieldRes: SYSEditorAssetType[] = JSON.parse(assetFieldValue)
  if (!Array.isArray(assetFieldRes)) {
    assetFieldRes = [assetFieldRes]
  }

  for (let i = 0; i < assetFieldRes.length; i++) {
    let assetDef = assetFieldRes[i]
    if (!assetDef) {
      continue
    }
    let instance = i.toString().padStart(2, "0")
    if (assetDef.desc !== undefined) {
      fields[`Desc_${instance}`].value = assetDef.desc
    }

    if (assetDef.ext !== undefined) {
      fields[`Ext_${instance}`].value = assetDef.ext
    }

    if (assetDef.val !== undefined) {
      fields[`Val_${instance}`].value = assetDef.val
    }

    if (assetDef.cat !== undefined) {
      let field = fields[`Category_${instance}`]
      if (field) {
        field.value = assetDef.cat
      }
    }

    if (assetDef.c !== undefined) {
      let chk0 = assetDef.c === 1
      fields[`Chk0_${instance}`].value = chk0
    }
  }
}
